import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { GMapState } from '../../common/types/interfaces'

const initialState: { data: GMapState } = {
  data: {
    sliderVisible: false,
  },
}

export const gMapSlice = createSlice({
  name: 'gmap',
  initialState,
  reducers: {
    toggleMapSlider: (state) => {
      state.data.sliderVisible = !state.data.sliderVisible
    },
  },
})

export const { toggleMapSlider } = gMapSlice.actions

export const selectMapSliderVisible = (state: RootState) => state.gMap.data.sliderVisible

export default gMapSlice.reducer
